import { Error } from '@square/dashboard-protos/models/squareup/connect/v2/resources/error';
/**
 * Call this function with an error to create a closure on that error and return
 * a function meant for Sentry to add context about the error.
 */
export function addProtoContext(error) {
  const protoMessage = error.protoMessage;
  const errors = protoMessage?.errors || [];

  /**
   * This function sets the rpc errors as additional context on a Sentry request.
   * By returning the scope object this could be chained or composed with
   * another similar context-adding function.
   */
  return function (scope) {
    if (errors.length > 0) {
      const errorEntries = errors.map(error => {
        const obj = Error.toObject(error, {
          enums: String
        });
        return [obj.code, obj.detail];
      });
      scope.setContext('Protobuf', Object.fromEntries(errorEntries));
    }
    return scope;
  };
}